import { render, staticRenderFns } from "./EditDocumentDialog.vue?vue&type=template&id=79fa7fb6&scoped=true"
import script from "./EditDocumentDialog.vue?vue&type=script&lang=js"
export * from "./EditDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDocumentDialog.vue?vue&type=style&index=0&id=79fa7fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fa7fb6",
  null
  
)

export default component.exports